import { AxiosResponse } from 'axios';
import qs from 'qs';

import ProductCategory from '~/@core/domain/model/product/ProductCategory';
import { ISiteIdParams } from '~/domain/model/PriceReport/PriceReportService';
import ProductGroupWithCategories from '~/domain/model/PriceReport/ProductGroupWithCategories';
import { IProductSimple } from '~/domain/model/PriceReport/ProductSimple';
import api from '~/services/api';

type Params = {
  [key: string]: unknown;
};

const paramsSerializer = <T extends Params>(params: T) =>
  qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true });

export const getProductCategories = (
  params: ISiteIdParams,
  permissionName: string
) => {
  const queryParams = {
    ...params,
    permissionName
  };

  return api.get<void, AxiosResponse<ProductCategory[]>>(
    `/product-category/by-site-ids`,
    {
      params: queryParams,
      paramsSerializer
    }
  );
};

export const getProductGroups = (
  params: ISiteIdParams,
  permissionName: string
) => {
  const queryParams = {
    ...params,
    permissionName
  };

  return api.get<void, AxiosResponse<ProductGroupWithCategories[]>>(
    `/product-group/by-site-ids`,
    {
      params: queryParams,
      paramsSerializer
    }
  );
};

export const getProductsSimple = (
  params: ISiteIdParams,
  permissionName: string
) => {
  const queryParams = {
    ...params,
    permissionName
  };

  return api.get<void, AxiosResponse<IProductSimple[]>>(
    `/product/simple/by-site-ids`,
    {
      params: queryParams,
      paramsSerializer
    }
  );
};
